import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "access_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("refresh_token");
};

// Build a token-authenticated URL for file downloads (export / preview).
export const backendUrl = () => API_URL;

const instance = axios.create({ baseURL: `${API_URL}/api` });

instance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const parseError = (error) => {
  if (error?.response?.status === 401) {
    clearToken();
    return new Error("SESSION_EXPIRED");
  }
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return new Error(detail);
  if (Array.isArray(detail))
    return new Error(detail.map((e) => e.msg || JSON.stringify(e)).join(" "));
  return new Error(error?.message || "Request failed");
};

export const apiClient = {
  async get(endpoint) {
    try {
      const res = await instance.get(endpoint);
      return res.data;
    } catch (e) {
      throw parseError(e);
    }
  },
  async post(endpoint, body) {
    try {
      const res = await instance.post(endpoint, body);
      return res.data;
    } catch (e) {
      throw parseError(e);
    }
  },
  async put(endpoint, body) {
    try {
      const res = await instance.put(endpoint, body);
      return res.data;
    } catch (e) {
      throw parseError(e);
    }
  },
  async del(endpoint) {
    try {
      const res = await instance.delete(endpoint);
      return res.data;
    } catch (e) {
      throw parseError(e);
    }
  },
  setToken,
  getToken,
  clearToken,
};
